import { render, staticRenderFns } from "./StaffDensity.vue?vue&type=template&id=249394bb&scoped=true&"
import script from "./StaffDensity.vue?vue&type=script&lang=js&"
export * from "./StaffDensity.vue?vue&type=script&lang=js&"
import style0 from "./StaffDensity.vue?vue&type=style&index=0&id=249394bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249394bb",
  null
  
)

export default component.exports